import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_565d3ba9-2a1e-4f21-9254-ebb492ca000d/artifacts/h2q109x3_FIRMA%20JPG.jpg"
              alt="Ando Viajando Adrogué"
              className="h-12 w-auto md:h-16 object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-[#003580] hover:text-[#FF6B35] font-medium transition-colors duration-300"
            >
              Inicio / Home
            </button>
            <button
              onClick={() => scrollToSection('resorts')}
              className="text-[#003580] hover:text-[#FF6B35] font-medium transition-colors duration-300"
            >
              Centros Invernales / Ski Resorts
            </button>
            <Button
              onClick={() => scrollToSection('configurator')}
              className="bg-[#FF6B35] hover:bg-[#E55A2B] text-white font-semibold px-6 py-2 rounded-lg shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105"
            >
              CONFIGURÁ TU VIAJE / PLAN YOUR TRIP
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-[#003580] p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-3">
            <button
              onClick={() => scrollToSection('hero')}
              className="block w-full text-left text-[#003580] hover:text-[#FF6B35] font-medium py-2 transition-colors duration-300"
            >
              Inicio / Home
            </button>
            <button
              onClick={() => scrollToSection('resorts')}
              className="block w-full text-left text-[#003580] hover:text-[#FF6B35] font-medium py-2 transition-colors duration-300"
            >
              Centros Invernales / Ski Resorts
            </button>
            <Button
              onClick={() => scrollToSection('configurator')}
              className="w-full bg-[#FF6B35] hover:bg-[#E55A2B] text-white font-semibold py-3 rounded-lg shadow-md"
            >
              CONFIGURÁ TU VIAJE / PLAN YOUR TRIP
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
